module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-152x152-ab9648319daaa768e74c9fc675f2adbc.png";